import { render, staticRenderFns } from "./MyCharges.vue?vue&type=template&id=5b3a0bf4"
import script from "./MyCharges.vue?vue&type=script&lang=js"
export * from "./MyCharges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports